import { Component, Fragment } from "react";
import React from "react";
import { MainStore } from "../../../stores/MainStore";
import { observer } from "mobx-react";
import Globe from "..";

/**
 * This component will handle performances on 3D Globe
 */
interface IProps {
  store: MainStore;
}

@observer
class GlobeReactor extends Component<IProps> {
  lastSelectedState = null;

  /**
   * Handles state update to render the globe only when the selection changes
   * @param nextProps
   * @param nextState
   */
  shouldComponentUpdate(nextProps: IProps, nextState: any) {
    const { store } = nextProps;
    const { selectedState } = store;
    const result = this.lastSelectedState !== selectedState;
    this.lastSelectedState = selectedState;
    return selectedState || result;
  }

  render() {
    const { store } = this.props;
    if (!store) return null;
    return (
      <Fragment>
        <Globe store={store} />
      </Fragment>
    );
  }
}
export default GlobeReactor;
